import { IDashboardAccessSetting, } from '../dashboard/useDashboardQueries';

export const hasAnyDashboardAccess = (
    roles: string[],    
    loginId: string,
    exemptedUsers: string[],
    dashboardAccessSetting: IDashboardAccessSetting[]
): boolean => {

    const filteredRoles = roles.filter(Boolean);

    const dashboardRoles = dashboardAccessSetting
        ?.filter((domain:any) => domain.enabled)
        ?.flatMap((dashboard) =>
        dashboard.roles.map((role) => role.toLowerCase()).filter(Boolean)
    );

    const userExempted = exemptedUsers.includes(loginId);

    return !userExempted && dashboardRoles?.some((dbRole) =>
        filteredRoles.some((userRole) =>
            dbRole.includes(userRole) || userRole.includes(dbRole)
        )
    );
};